import { EditIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { httpsCallable } from 'firebase/functions'
import moment from 'moment'
import React, { useState } from 'react'
import { FaVial } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import useStore from '../../../store/useStore'
import { getEffectiveServices } from '../../../utils/firebaseServiceContext'

interface NavigationActionsProps {
  month: string
}

const NavigationActions: React.FC<NavigationActionsProps> = ({ month }) => {
  const reports = useStore((s) => s.reports)
  const isImpersonating = useStore(
    (state) => state.identityStatus === 'impersonating',
  )

  const prevMonth = moment(month, 'YYYY-MM')
    .subtract(1, 'month')
    .format('YYYY-MM')
  const currentMonthName = moment(month, 'YYYY-MM').format('MMMM')
  const prevMonthName = moment(month, 'YYYY-MM')
    .subtract(1, 'month')
    .format('MMMM')

  const currentComplete = reports[month]?.allStepsCompleted === true
  const prevComplete = reports[prevMonth]?.allStepsCompleted === true

  const [sentMonthName, setSentMonthName] = useState<string | null>(null)
  const [isSending, setIsSending] = useState(false)

  const handleSendEmail = (reportMonth: string, monthName: string) => {
    setIsSending(true)
    httpsCallable(
      getEffectiveServices().functions,
      'sendCheckInCompleteEmailCallable',
    )({ month: reportMonth })
      .then(() => setSentMonthName(monthName))
      .catch(console.error)
      .finally(() => setIsSending(false))
  }

  return (
    <Flex wrap='wrap'>
      <Box mt={1} mr={2}>
        <Link to={`/report/${month}/1`}>
          <Button rightIcon={<EditIcon />}>Do Your Monthly Check-In</Button>
        </Link>
      </Box>
      <Box mt={1} mr={2}>
        <Link to='/labs'>
          <Button variant='outline' rightIcon={<FaVial />}>
            Lab Tests
          </Button>
        </Link>
      </Box>
      {currentComplete && !isImpersonating && (
        <Box mt={1} mr={2}>
          <Button
            colorScheme='purple'
            variant='outline'
            isLoading={isSending}
            onClick={() => handleSendEmail(month, currentMonthName)}
          >
            Email {currentMonthName} confirmation
          </Button>
        </Box>
      )}
      {prevComplete && !isImpersonating && (
        <Box mt={1} mr={2}>
          <Button
            colorScheme='purple'
            variant='outline'
            isLoading={isSending}
            onClick={() => handleSendEmail(prevMonth, prevMonthName)}
          >
            Email {prevMonthName} confirmation
          </Button>
        </Box>
      )}
      <Modal
        isOpen={sentMonthName !== null}
        onClose={() => setSentMonthName(null)}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Email Sent</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              Your {sentMonthName} confirmation email has been sent
              successfully.
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='purple' onClick={() => setSentMonthName(null)}>
              OK
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  )
}

export default NavigationActions
